/* import __COLOCATED_TEMPLATE__ from './intercom-select-dropdown.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();